<ng-container [ngSwitch]="data">
  <div *ngIf="data == '1'">Revenue per action (RPA)</div>
</ng-container>
